function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.536.636c-.026.569-.006 1.14-.006 1.72H7.51V1.19c-.229.06-.437.115-.644.171-1.536.42-3.072.84-4.61 1.256-.11.03-.144.077-.144.192l.003 4.993v5.144h5.387V4.048c0-.448.185-.636.625-.637l6.218-.004c.359 0 .565.205.565.567v6.055c0 .047-.004.093-.007.149h-1.015v-5.72H8.541v8.486c.026.003.055.012.085.012L16 12.954V14H0v-1.046h1.09V2.402c0-.438.1-.568.514-.681C3.658 1.16 5.714.609 7.762.03c.444-.126.795.145.774.605zm3.869 9.91v1.012H9.98v-1.013h2.424zm-6.386 0v1.012H3.596v-1.012h2.423zm.006-2.37v1.02H3.6v-1.02h2.426zm6.38.001v1.017H9.982V8.177h2.425zm-.008-2.37v1.02H9.974v-1.02h2.423zM6.02 5.804v1.02H3.596v-1.02H6.02zm.002-2.365v1.02H3.598V3.44h2.424z",
  id: "a"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 5)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "var(--light-grey)",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "var(--light-grey)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4 19h24V-5H-4z"
})));

function SvgIconCompanies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompanies);
export default __webpack_public_path__ + "static/media/icon-companies.23dad2f9.svg";
export { ForwardRef as ReactComponent };